module.exports = __webpack_public_path__ + "img/monstercrossing.2e205573.jpg";